import { render, staticRenderFns } from "./TabIcon.vue?vue&type=template&id=9b792d90&scoped=true"
import script from "./TabIcon.vue?vue&type=script&lang=js"
export * from "./TabIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b792d90",
  null
  
)

export default component.exports